// 承运商是4PX
export const isFourPxFn = (companyCode) => companyCode === '4PX'
// 承运商是ZEEK
export const isZEEKFn = (companyCode) => companyCode === 'HKZEEK'

/**
 * 是否是跨境
 * 条件：发件国家和收件国家不同
 */
export const isCrossBorderFn = (departureCountryCode, arrivalCountryCode) => departureCountryCode !== arrivalCountryCode
/**
 * 是否是中国跨境
 * 条件：发件国家是中国大陆，收件国家非中国大陆
 */
export const isMainlandCrossBorderFn = (departureCountryCode, arrivalCountryCode) => departureCountryCode === 'CN' && 'CN' !== arrivalCountryCode

/**
 * 跨境收件地区是台湾
 * 条件：收件地区是台湾，发件地区是非台湾
 */
export const isTWCrossBorderFn = (departureCountryCode, arrivalCountryCode) => departureCountryCode !== 'TW' && arrivalCountryCode === 'TW'

/**
 * HK kerry 香港-台湾
 * 条件：
 * 1. 寄件地址countryCode === 'HK'
 * 2. 收件地址countryCode === 'TW'
 * 3. 承运商是companyCode === 'HK_KERRY'
 */
export const isKerryHk2TWFn = (companyCode, departureCountryCode, arrivalCountryCode) => {
  return companyCode === 'HK_KERRY' && departureCountryCode === 'HK' && arrivalCountryCode === 'TW'
}
